export default {
  title_1: 'Pourquoi avez-vous besoin d’un portefeuille matériel ?',
  desc_1_1:
    'Parce que le Web3 est bâti sur des contrats intelligents, il introduit des risques pour de nombreux utilisateurs.',
  desc_1_2:
    'Lors de la création d’un portefeuille ou de la signature de transactions, votre téléphone ou ordinateur peut être exposé à des intrusions, des malwares ou une surveillance du presse-papiers. Un appareil dédié renforce votre sécurité sur le Web3.',
  desc_1_3: 'Dans ce contexte, le portefeuille matériel est l’un des meilleurs choix.',

  title_2: 'Pourquoi un portefeuille matériel est-il sécurisé ?',
  desc_2_1: 'Puces de sécurité',
  desc_2_2: 'Aide à créer le portefeuille',
  desc_2_3: 'Stockage sécurisé',
  desc_2_4: 'Clés gérées et stockées hors ligne',
  desc_2_5: 'Évite le piratage',
  desc_2_6: 'Éloigne des arnaques',

  title_3: 'Pourquoi KeyPal ?',
  desc_3_1: 'Double puce',
  desc_3_2:
    'KeyPal adopte une architecture à double puce : MCU anti-altération et puce de sécurité SE.',
  desc_3_3: 'Certification anti-contrefaçon',
  desc_3_4:
    'Chaque appareil KeyPal possède un certificat d’identité unique et un numéro de série gravé au laser au dos, utilisés pour la vérification anti-contrefaçon en ligne.',
  desc_3_5: 'Empêche la transmission de données sensibles',
  desc_3_6:
    'KeyPal communique avec l’application via Bluetooth double canal et USB. En Bluetooth, la couche de liaison ne transmet aucune donnée sensible, empêchant toute interception.',
  desc_3_7: 'Code PIN',
  desc_3_8:
    'Lors de la création ou restauration du portefeuille, un PIN de démarrage est requis ; il doit être saisi à chaque allumage. En cas d’erreurs consécutives, l’appareil est réinitialisé et toutes les données supprimées afin d’éviter tout accès en cas d’erreur, de perte ou de vol.',
  desc_3_9:
    'KeyPal respecte les standards BIP32/BIP39/BIP44 et fournit un environnement hors ligne pour générer, gérer et protéger les mnémoniques. Avec Bluetooth chiffré, protection PIN et écran couleur 2,0", chaque transaction signée est affichée pour « SIGNER CE QUE VOUS VOYEZ », empêchant les falsifications et attaques de type homme-du-milieu.',

  SE_desc_1: '1. Générateur de nombres aléatoires véritable intégré',
  SE_desc_2: '2. Stockages sécurisés multiples',
  SE_desc_3: '3. La graine ne quitte jamais la puce',
  SE_desc_4: '4. Résiste au brute force et bloque la lecture externe',
  MCU_desc_1: '1. Chiffrement de niveau bancaire',
  MCU_desc_2: '2. Sécurité système et détection de falsification',
  MCU_desc_3: '3. Résistance aux attaques externes et à l’injection de code',
};
